module.exports = __webpack_public_path__ + "img/ALTK.a320bde0.png";